import React from 'react'
import { Box, Td, Tr, Tbody, TableContainer, Table, Thead, Th, Text } from '@chakra-ui/react'

export default function SummaryTable({ data }) {
    return (
        <Box mt={1} className='custom_table_wrapper report-table'>
            <TableContainer>
                <Table variant="striped">
                    <Thead>
                        <Tr>
                            <Th>Particular</Th>
                            <Th>Total</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data?.map((item, index) => {
                            return (
                                <Tr key={index}>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Particular}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Total}</Text>
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    )
}
